/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateExerciseFactDTO,
  ExerciseFactDTO,
  UpdateExerciseFactDTO,
} from '../models/index';
import {
    CreateExerciseFactDTOFromJSON,
    CreateExerciseFactDTOToJSON,
    ExerciseFactDTOFromJSON,
    ExerciseFactDTOToJSON,
    UpdateExerciseFactDTOFromJSON,
    UpdateExerciseFactDTOToJSON,
} from '../models/index';

export interface ExerciseFactCreateRequest {
    createExerciseFactDTO: CreateExerciseFactDTO;
}

export interface ExerciseFactUpdateRequest {
    updateExerciseFactDTO: UpdateExerciseFactDTO;
}

/**
 * 
 */
export class ExerciseFactApi extends runtime.BaseAPI {

    /**
     */
    async exerciseFactCreateRaw(requestParameters: ExerciseFactCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExerciseFactDTO>> {
        if (requestParameters['createExerciseFactDTO'] == null) {
            throw new runtime.RequiredError(
                'createExerciseFactDTO',
                'Required parameter "createExerciseFactDTO" was null or undefined when calling exerciseFactCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/exercise-fact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateExerciseFactDTOToJSON(requestParameters['createExerciseFactDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExerciseFactDTOFromJSON(jsonValue));
    }

    /**
     */
    async exerciseFactCreate(requestParameters: ExerciseFactCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExerciseFactDTO> {
        const response = await this.exerciseFactCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async exerciseFactListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExerciseFactDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/exercise-fact`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExerciseFactDTOFromJSON));
    }

    /**
     */
    async exerciseFactList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExerciseFactDTO>> {
        const response = await this.exerciseFactListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async exerciseFactUpdateRaw(requestParameters: ExerciseFactUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExerciseFactDTO>> {
        if (requestParameters['updateExerciseFactDTO'] == null) {
            throw new runtime.RequiredError(
                'updateExerciseFactDTO',
                'Required parameter "updateExerciseFactDTO" was null or undefined when calling exerciseFactUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/exercise-fact`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateExerciseFactDTOToJSON(requestParameters['updateExerciseFactDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExerciseFactDTOFromJSON(jsonValue));
    }

    /**
     */
    async exerciseFactUpdate(requestParameters: ExerciseFactUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExerciseFactDTO> {
        const response = await this.exerciseFactUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
